import { useNavigate } from 'react-router-dom';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import strFunc from '@/lib/lyg/string';
import { text } from 'stream/consumers';

function ToTalArea(props: any) {
  let myProps = {
    Style: {},
    chat: {},
    ...props
  };
  let Style = myProps.Style;
  let chat = myProps.chat;
  let user = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const [mcomp_point, set_mcomp_point] = useState<any>(0);

  useEffect(() => {
    getPointNumByAjax();
  }, [user]);

  const getPointNumByAjax = () => {
    if (user.comp_seq) {

    } else {
      return false;
    }
    let point_form_json = {
      "s_seq": [user.comp_seq],
      "is_addon_point_tot": "1",
      "is_paging": "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list', point_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let corp_info = response.data["data"]["info_arr"][0];
            if (corp_info.point_tot_info) {
              set_mcomp_point(corp_info.point_tot_info.tot);
            }
          }
        } else {

        }
      });
  };

  let tot_div_wrap_style: any = {
    borderTop: "1px solid #eee", borderBottom: "1px solid #eee", position: "relative",
    textAlign: "center"
  };

  return (
    <div className="con_wrap" style={tot_div_wrap_style}>
      <div className={Style.total_cnt_box} style={{ marginLeft: 0 }}>
        <span className={Style.total_cnt_box_title} >플랜톡</span>
        <span className={Style.total_cnt_box_num}>{chat.unreadToT}</span>
      </div>
      <div className={Style.total_cnt_box}>
        <span className={Style.total_cnt_box_title} >어제학습현황</span>
        <span className={Style.total_cnt_box_num}>0%</span>
      </div>
      <div className={Style.total_cnt_box}>
        <span className={Style.total_cnt_box_title} >포인트</span>
        <span className={Style.total_cnt_box_num}>
          {strFunc.comma(mcomp_point)}
          <button className='btn btn-dark ml-2'
            onClick={() => {
              navigate("/comp/basic/corp/main");
            }}
          >포인트 충전으로 이동</button>
        </span>
      </div>
      <a className={Style.top_area_comp_manage_btn} onClick={() => { navigate("/home"); }} >홈페이지{" >"}</a>
    </div>
  );
};
export default ToTalArea;